<template>
    <v-container fill-height>
      <v-row>
        <v-col>
          <div class="d-flex flex-column justify-center align-center">
        <h1 class="text-h1 mb-5">
          404
        </h1>
        <h2 class="text-h2">
          聽日準時返工啊
        </h2>
      </div>
        </v-col>
      </v-row>
    </v-container>
</template>

<script>
export default {
}
</script>

<style lang="scss">
</style>
